<template>
  <div>
    <div class="landing-page pa-4">
      <div class="header-container ma-4">
        <div class="header-content">
          <div class="logo-and-menu">
            <div class="logo-container">
              <img
                src="/static/images/landing-page/ys_logo_primary-black.svg"
                @click="navigateTo('/')"
                class="cursor-pointer"
                aspect-ratio="1"
                height="24"
                width="124"
              />
            </div>
            <div class="links-container white--text font-space-grotesk font-weight-700 text-18">
              <span
                class="menu-item cursor-pointer"
                :class="{ 'active-menu': isUpgrade }"
                @click="isUpgrade = true"
              >
                Upgrade
              </span>
              <span
                class="menu-item cursor-pointer"
                @click="navigateTo('/for-creators')"
              >
                Creators
              </span>
              <span
                class="menu-item cursor-pointer"
                @click="navigateTo('/login')"
              >
                Signin
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="main-content">
        <v-layout v-if="!isUpgrade" align-center justify-space-around row gap-8>
          <div class="blurb-container">
            <div class="text-container white--text font-space-grotesk font-weight-500">
              <span class="text-50">
                Music Streaming <br />
                Reinvented.
              </span>
              <div class="app-icons-container">
                <v-layout align-center row mt-4 pt-4>
                  <div class="app-icon-container">
                    <img
                      src="/static/images/landing-page/apple-store.svg"
                      aspect-ratio="1"
                      height="54"
                      width="187"
                    />
                  </div>
                  <div class="app-icon-container">
                    <img
                      src="/static/images/landing-page/google-play.svg"
                      aspect-ratio="1"
                      height="54"
                      width="187"
                    />
                  </div>
                </v-layout>
              </div>
            </div>
          </div>
          <div class="image-container">
            <div class="image-wrapper">
              <img
                src="/static/images/landing-page/ys-landing-ios.png"
                aspect-ratio="1"
                height="805"
                width="452"
              />
            </div>
          </div>
        </v-layout>
        <UpgradePlan v-else :category-plan="categoryPlan" class="pa-5" />
      </div>
    </div>

    <div class="fqa bg-grey-white">
      <v-layout align-center justify-center column>
        <div
          class="text-40 font-space-grotesk font-weight-500 fqa__title w-100 pb-4 mb-3 text-center"
        >
          FAQ
        </div>

        <div v-if="categoryPlan == 'creator'">
          <div
            v-for="(faq, index) in creatorFaqs"
            :key="index"
            class="bg-white fqa__wrapper w-100 font-dm-sans mb-4"
          >
            <div
              :class="[
                'text-22 font-weight-700 text-grey-purple cursor-pointer',
                faq.open ? 'mb-4' : 'mb-2'
              ]"
              @click="toggleFaq(index, 'creator')"
            >
              {{ faq.question }}
            </div>
            <div v-if="faq.open" class="text-18 font-weight-500">
              <div v-html="faq.answer"></div>
            </div>
          </div>
        </div>

        <div v-else>
          <div
            v-for="(faq, index) in generalFaqs"
            :key="index"
            class="bg-white fqa__wrapper w-100 font-dm-sans mb-4"
          >
            <div
              :class="[
                'text-22 font-weight-700 text-grey-purple cursor-pointer',
                faq.open ? 'mb-4' : 'mb-2'
              ]"
              @click="toggleFaq(index, 'general')"
            >
              {{ faq.question }}
            </div>
            <div v-if="faq.open" class="text-18 font-weight-500">
              <div v-html="faq.answer"></div>
            </div>
          </div>
        </div>
      </v-layout>
    </div>

    <FooterLandingPage />
  </div>
</template>

<script>
import UpgradePlan from "./UpgradePlan.vue";
import FooterLandingPage from "./FooterLandingPage.vue";

export default {
  components: {
    UpgradePlan,
    FooterLandingPage,
  },
  data() {
    return {
      isUpgrade: false,
      categoryPlan: "creator",
      creatorFaqs: [
        {
          question: "How much do creators keep on sales?",
          answer:
            "Creators keep 90% of all sales, including digital sales & membership revenue.",
          open: false,
        },
        // Add more FAQs here
      ],
      generalFaqs: [
        {
          question: "What is YouSound?",
          answer:
            "YouSound is a unique music streaming service that combines traditional streaming with a membership model. It allows fans to enjoy a wide range of music while providing an option to support their favorite artists more deeply through memberships.",
          open: false,
        },
        // Add more FAQs here
      ],
    };
  },
  methods: {
    navigateTo(path) {
      this.isUpgrade = false;
      this.$router.push({ path });
    },
    toggleFaq(index, category) {
      const faqList = category === "creator" ? this.creatorFaqs : this.generalFaqs;
      faqList.forEach((faq, i) => {
        if (i !== index) {
          faq.open = false;
        }
      });
      this.$set(faqList, index, {
        ...faqList[index],
        open: !faqList[index].open,
      });
    },
  },
  watch: {
    $route() {
      this.isUpgrade = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-page {
  background-image: url("/static/images/bg-landing-page.svg");
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header-container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 40px;
}

.header-content {
  max-width: 1200px; /* Adjust this value as needed */
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 110px;
}

.logo-and-menu {
  display: flex;
  align-items: center;
}

.logo-container {
  display: flex;
  justify-content: flex-start;
  margin-right: 20px;
}

.links-container {
  display: flex;
  justify-content: flex-start;
  margin-left: 40px; /* Adjust this value to set space between the logo and the menu */
}

.menu-item {
  margin-right: 50px; /* Adjust this value to set equal space between menu items */
  position: relative;
  line-height: 24px; /* Ensure the line-height matches the logo height */
}

.menu-item::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px; /* Adjust this value to control the underline position */
  width: 100%;
  height: 2px;
  background-color: white;
  transform: scaleX(0);
  transform-origin: bottom right;
  transition: transform 0.3s ease;
}

.menu-item:hover::after,
.active-menu::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.main-content {
  max-width: 1200px; /* Adjust this value as needed */
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.line {
  margin-top: 50px;
  background: #555;
  height: 1px;
}

.blurb-container {
  display: flex;
  flex-direction: column;
}

.text-container {
  max-width: 600px;
  margin-top: -130px;
  /* Adjust this value as needed */
}

.app-icons-container {
  margin-top: 20px; /* Adjust this value to move the app icons up or down */
}

.image-container {
  max-width: 500px;
}

.image-wrapper {
  margin-top: 20px; /* Adjust this value to move the image up or down */
  margin-right: -80px;
}

.app-icon-container {
  margin-right: 15px;
  margin-top: 40px;
}

.app-icon-container:last-child {
  margin-right: 0;
}

.fqa {
  padding: 60px 40px 40px;
  &__title {
    max-width: 800px;
  }
  &__wrapper {
    min-width: 800px;
    max-width: 800px;
    border-radius: 10px;
    padding: 20px 30px;
    box-shadow: 0 0 4px 0px #0000001f;
  }
}

.cursor-pointer {
  cursor: pointer;
}

.footer-background {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// ForCreators.vue?5b27b42c